import SwiperCore, { Pagination, Autoplay, EffectCreative, EffectFade, Thumbs } from 'swiper/core';

SwiperCore.use([Pagination, Autoplay, EffectCreative, EffectFade, Thumbs]);
const mq = window.matchMedia('(min-width: 992px)');
(function () {
	const homepageContainer = document.querySelector('.hp-slider__wrapper');
	const nav = document.querySelector('.nav');

	if (!homepageContainer) return;

	if (mq.matches) {
		homepageContainer.style.height = `calc(100vh - ${nav.clientHeight}px - 48px)`;

		new SwiperCore(homepageContainer, {
			speed: 1200,
			spaceBetween: 40,
			centeredSlides: true,
			preventInteractionOnTransition: true,
			autoplay: {
				delay: 5000,
			},
			grabCursor: true,
			effect: 'creative',
			slidesPerView: 1.1,
			creativeEffect: {
				limitProgress: 4,
				prev: {
					translate: ['-102%', 0, 0],
					origin: `right top`,
					scale: 0.9,
				},
				next: {
					translate: ['102%', 0, 0],
					scale: 0.85,
					origin: `left top`,
				},
			},
			loop: true,
		});
	} else {
		homepageContainer.style.height = `calc(100vh - ${nav.clientHeight}px)`;

		new SwiperCore(homepageContainer, {
			speed: 1200,
			spaceBetween: 40,
			centeredSlides: true,
			preventInteractionOnTransition: true,
			autoplay: {
				delay: 5000,
			},
			grabCursor: true,
			effect: 'creative',
			slidesPerView: 1.1,
			creativeEffect: {
				limitProgress: 4,
				prev: {
					translate: ['-102%', 0, 0],
					origin: `right top`,
					scale: 0.9,
				},
				next: {
					translate: ['102%', 0, 0],
					scale: 0.85,
					origin: `left top`,
				},
			},
			loop: true,
		});
	}
})();
